import * as React from 'react';

export const AngleRight = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="angle-right-small">
      <path
        id="Vector"
        d="M8.33332 14.1685C8.11999 14.1685 7.90663 14.0869 7.74413 13.9244C7.4183 13.5986 7.4183 13.0718 7.74413 12.746L10.4883 10.0019L7.74413 7.25772C7.4183 6.93189 7.4183 6.40517 7.74413 6.07934C8.06996 5.7535 8.59668 5.7535 8.92252 6.07934L12.2558 9.41267C12.5817 9.7385 12.5817 10.2652 12.2558 10.5911L8.92252 13.9244C8.76002 14.0869 8.54666 14.1685 8.33332 14.1685Z"
        fill="black"
      />
    </g>
  </svg>
);
